import { render, staticRenderFns } from "./control-promotions.vue?vue&type=template&id=478e9833&"
import script from "./control-promotions.vue?vue&type=script&lang=js&"
export * from "./control-promotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('478e9833')) {
      api.createRecord('478e9833', component.options)
    } else {
      api.reload('478e9833', component.options)
    }
    module.hot.accept("./control-promotions.vue?vue&type=template&id=478e9833&", function () {
      api.rerender('478e9833', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/header/control-promotions.vue"
export default component.exports